import { Roles } from "@/helpers/enums/Roles";

export default [
  // {
  //   path: ":param",
  //   component: () => import("@/views/pages/AlertConsole/List.vue"),
  //   meta: {
  //     title: "unresolved",
  //   },
  // },
  {
    path: "unresolved",
    component: () => import("@/views/pages/AlertConsole/List.vue"),
    meta: {
      title: "alertConsole",
    },
  },
  {
    path: "all",
    component: () => import("@/views/pages/AlertConsole/List.vue"),
    meta: {
      title: "alertConsole",
    },
  },
  {
    path: "inreview",
    component: () => import("@/views/pages/AlertConsole/List.vue"),
    meta: {
      title: "alertConsole",
    },
  },
  {
    path: "resolved",
    component: () => import("@/views/pages/AlertConsole/List.vue"),
    meta: {
      title: "alertConsole",
    },
  },
  {
    path: "configuration/security-alerts",
    component: () => import("@/views/pages/AlertConsole/SecurityAlerts.vue"),
    meta: {
      title: "alertConfiguration",
      roles: [
        Roles.PartnerAdmin,
        Roles.CompanyAdmin,
        Roles.GroupAdmin,
        Roles.GroupAudit,
        Roles.SiteAdmin,
        Roles.SiteAudit,
      ],
    },
  },
  {
    path: "configuration/system-alerts",
    component: () => import("@/views/pages/AlertConsole/SystemAlerts.vue"),
    meta: {
      title: "alertConfiguration",
      roles: [Roles.AGMSAdmin],
    },
  },
  {
    path: "configuration/deployment-health-alerts",
    component: () =>
      import("@/views/pages/AlertConsole/DeploymentHealthAlerts.vue"),
    meta: {
      title: "alertConfiguration",
      roles: [
        Roles.PartnerAdmin,
        Roles.CompanyAdmin,
        Roles.GroupAdmin,
        Roles.GroupAudit,
        Roles.SiteAdmin,
        Roles.SiteAudit,
      ],
    },
  },
  {
    path: "configuration/live-site-alerts",
    component: () => import("@/views/pages/AlertConsole/LiveSiteAlerts.vue"),
    meta: {
      title: "alertConfiguration",
      roles: [Roles.AGMSAdmin],
    },
  },
];
